import ddexStoresData from "../../data/mockData/ddexStoresData";
import { types } from "./action";

const initialState = ddexStoresData;

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DDEX_STORES:
      return action.payload || state;
    default:
      return state;
  }
};
